class TitaniumSpectrum extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    const output = this.querySelector('[data-spectrum-output]');

    this.querySelectorAll('button[data-tone]').forEach((button) => {
      button.addEventListener('click', () => {
        this.dataset.tone = button.dataset.tone;
        this.querySelectorAll('button[data-tone]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        output.textContent = button.dataset.label;
      });
    });
  }
}

class TitaniumHeroMotion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.motionReady === 'true') return;

    this.dataset.motionReady = 'true';
    this.hero = this.closest('.titanium-home__hero');
    this.scrollRoot = this.closest('.page-wrapper');
    this.scrollTarget = this.scrollRoot || window;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.compactViewport = window.matchMedia('(max-width: 600px)').matches;
    this.currentProgress = 0;
    this.targetProgress = 0;
    this.frame = 0;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.animate = this.animate.bind(this);

    if (this.reducedMotion || this.compactViewport) {
      this.render(1);
      return;
    }

    this.scrollTarget.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.measure();
    this.targetProgress = this.getProgress();
    this.currentProgress = this.targetProgress;
    this.render(this.currentProgress);
  }

  disconnectedCallback() {
    this.scrollTarget?.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    if (this.frame) window.cancelAnimationFrame(this.frame);
  }

  measure() {
    const viewportHeight = this.scrollRoot?.clientHeight || window.innerHeight;
    this.travel = Math.max(1, this.hero.offsetHeight - viewportHeight);
  }

  getProgress() {
    const heroTop = this.hero.getBoundingClientRect().top;
    const scrollTop = this.scrollRoot?.getBoundingClientRect().top || 0;
    const distance = Math.min(this.travel, Math.max(0, scrollTop - heroTop));
    return distance / this.travel;
  }

  handleScroll() {
    this.targetProgress = this.getProgress();
    if (!this.frame) this.frame = window.requestAnimationFrame(this.animate);
  }

  handleResize() {
    this.measure();
    this.handleScroll();
  }

  animate() {
    this.currentProgress += (this.targetProgress - this.currentProgress) * 0.12;
    this.render(this.currentProgress);

    if (Math.abs(this.targetProgress - this.currentProgress) > 0.001) {
      this.frame = window.requestAnimationFrame(this.animate);
    } else {
      this.currentProgress = this.targetProgress;
      this.render(this.currentProgress);
      this.frame = 0;
    }
  }

  render(progress) {
    const eased = progress * progress * (3 - 2 * progress);
    const revealRadius = 12 + eased * 106;
    const bloomRadius = 8 + eased * 76;
    this.style.setProperty('--hero-reveal-core', `${Math.max(0, revealRadius - 18)}%`);
    this.style.setProperty('--hero-reveal-radius', `${revealRadius}%`);
    this.style.setProperty('--hero-bloom-core', `${Math.max(0, bloomRadius - 24)}%`);
    this.style.setProperty('--hero-bloom-radius', `${bloomRadius}%`);
    this.style.setProperty('--hero-color-opacity', `${0.42 + eased * 0.58}`);
    this.style.setProperty('--hero-bloom-opacity', `${Math.sin(progress * Math.PI) * 0.28}`);
    this.style.setProperty('--hero-image-y', `${progress * -14}px`);
    this.style.setProperty('--hero-image-scale', `${1.025 + progress * 0.018}`);
    this.style.setProperty('--hero-copy-y', `${progress * -14}px`);
  }
}

if (!customElements.get('titanium-spectrum')) {
  customElements.define('titanium-spectrum', TitaniumSpectrum);
}

if (!customElements.get('titanium-hero-motion')) {
  customElements.define('titanium-hero-motion', TitaniumHeroMotion);
}
